import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  headLine: {
    fontWeight: 'bold',
    fontSize: 14,
    listStyle: 'none',
    marginBottom: theme.spacing(1),
  },
  usageItem: {
    fontSize: 12,
    fontWeight: 'normal',
    listStyle: 'none',
    marginBottom: 5,
    marginInlineStart: theme.spacing(1),
    position: 'relative',
    paddingInlineStart: theme.spacing(1.5),
    '&::before': {
      content: `" "`,
      position: 'absolute',
      left: 0,
      top: 6,
      width: 5,
      height: 5,
      borderRadius: 4,
    },
  },
  listHeadLine: {
    fontSize: 12,
    listStyle: 'none',
    marginTop: theme.spacing(1.5),
    marginBottom: 5,
    paddingInlineStart: theme.spacing(0),
  },
  listHeadLineValue: {
    fontWeight: 'bold',
    fontSize: 12,
    listStyle: 'none',
    marginTop: theme.spacing(1.5),
    marginBottom: 5,
    paddingInlineStart: theme.spacing(0),
  },
}));